import Layout from '@/components/Layout';
import Terms from '@/components/Terms';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ReactElement } from 'react';

const TermsPage = (
  _props: InferGetServerSidePropsType<typeof getServerSideProps>,
) => {
  return <Terms locale={_props.locale} />;
};

TermsPage.getLayout = (page: ReactElement) => (
  <Layout hasBackground={true} hasFooter={true}>
    {page}
  </Layout>
);

TermsPage.type = 'public';

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale ?? 'en', [
        'validate',
        'common',
        'aboutUs',
      ])),
      // Will be passed to the page component as props
      locale,
    },
  };
}

export default TermsPage;
